var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass:
        "border border-[#C8C8C8] lg:border-0 p-[20px] lg:py-[27px] hover:bg-yellow transition-colors cursor-pointer",
      attrs: { href: _vm.estateUrl }
    },
    [
      _c("div", { staticClass: "lg:hidden" }, [
        _c(
          "div",
          {
            staticClass:
              "text-black font-bold text-[20px] leading-[21px] mb-[8px]"
          },
          [_vm._v(_vm._s(_vm.unit.box))]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex flex-row justify-between items-center" },
          [
            _c("div", { staticClass: "text-[#929292] grid gap-[4px]" }, [
              _c(
                "div",
                { staticClass: "text-[16px] leading-[21px] font-regular" },
                [
                  _vm.unit.sub_type
                    ? [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$t(
                                "sweepbright.sub_types." + _vm.unit.sub_type
                              )
                            ) +
                            "\n                    "
                        )
                      ]
                    : [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$t("sweepbright.types." + _vm.unit.type)
                            ) +
                            "\n                    "
                        )
                      ]
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-[16px] leading-[21px] font-regular" },
                [_vm._v(_vm._s(_vm.unit.city))]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-[16px] leading-[21px] font-regular" },
                [_vm._v(_vm._s(_vm.unit.bedrooms) + " slaapkamers")]
              )
            ]),
            _vm._v(" "),
            _c("estate-price", {
              staticClass: "text-[20px] font-regular leading-[21px] text-black",
              attrs: {
                sign: "EUR",
                "label-class":
                  "!text-[20px] !font-regular !leading-[21px] !text-black",
                price: _vm.unit.price,
                status: _vm.unit.status,
                negotiation: _vm.unit.negotiation
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "hidden lg:grid grid-cols-7 items-center" },
        [
          _c("div", { staticClass: "text-[20px] leading-[21px] font-bold" }, [
            _vm._v(_vm._s(_vm.unit.box))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-[20px] leading-[21px] text-center" },
            [
              _vm.unit.sub_type
                ? [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t("sweepbright.sub_types." + _vm.unit.sub_type)
                        ) +
                        "\n            "
                    )
                  ]
                : [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("sweepbright.types." + _vm.unit.type)) +
                        "\n            "
                    )
                  ]
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-[20px] leading-[21px] text-center" }, [
            _vm._v(_vm._s(_vm.unit.floor))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-[20px] leading-[21px] text-center" },
            [
              _vm.unit.sizes && _vm.unit.sizes.liveable_area
                ? [
                    _vm._v(
                      " " + _vm._s(_vm.unit.sizes.liveable_area.size) + " "
                    ),
                    _c("small", { staticClass: "lowercase" }, [_vm._v("m²")])
                  ]
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "text-[20px] leading-[21px] text-center" }, [
            _vm._v(_vm._s(_vm.unit.bedrooms))
          ]),
          _vm._v(" "),
          _c("estate-price", {
            staticClass: "!text-black text-[20px] leading-[21px] text-center",
            attrs: {
              sign: "EUR",
              "label-class": ["sold"].includes(_vm.unit.status)
                ? "!text-gray-800 !text-[20px] !leading-[21px] !text-center"
                : "!text-black !text-[20px] !leading-[21px] !text-center",
              price: _vm.unit.price,
              status: _vm.unit.status,
              negotiation: _vm.unit.negotiation
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "text-[16px] font-extraBold text-right uppercase flex flex-wrap gap-[4px] justify-end"
            },
            [
              _vm._v("\n            bekijk unit\n            "),
              _c("span", {
                staticClass: "rotate-[-90deg]",
                domProps: { innerHTML: _vm._s(_vm.svg("chevron")) }
              })
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }